// extracted by mini-css-extract-plugin
export default {"page":"Full_page__yvqk0","bold":"Full_bold__jPWdR","demoCopy":"Full_demoCopy__Xv1wK"};